import { Injectable } from '@angular/core';
import { IMember } from 'src/app/models/member.model';
import { Provider } from '../provider';

@Injectable()
export class MemberService extends Provider<IMember>{
    protected url = "users/organisations/members";
}
